import { render } from "./BarcodeLinkScanRfid.vue?vue&type=template&id=200b5275&scoped=true"
import script from "./BarcodeLinkScanRfid.vue?vue&type=script&lang=ts"
export * from "./BarcodeLinkScanRfid.vue?vue&type=script&lang=ts"

import "./BarcodeLinkScanRfid.vue?vue&type=style&index=0&id=200b5275&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-200b5275"

export default script